<template>
  <header class="header">
    <section class="header__section">
      <h1 class="header__title">
        <router-link
          :to="{ path: `/${langPath}company/summary` }"
          class="top-link"
        >
          <img
            src="../../../assets/images/logo.svg"
            alt="TMF VIRTUAL RUN TOKYO MARATHON FOUNDATION"
            width="205px"
            height="30px"
          />
        </router-link>
      </h1>
      <input
        type="checkbox"
        v-model="checked"
        id="check-hamburger"
        class="none-checkbox"
      />
      <label for="check-hamburger" class="header__menu">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </label>
      <label for="check-hamburger" class="none-checkbox layer-hamburger">
      </label>
      <div class="hamburger-contents">
        <button type="button" @click="onLogout" class="logout-button">{{
          headerJson.logout[lang]
        }}</button>
        <!--        <router-link-->
        <!--          :to="{ path: `/${langPath}company/confirmation` }"-->
        <!--          class="hamburger-contents__confirm-link flex-all-center"-->
        <!--        >-->
        <!--          {{ headerJson.oauth[lang] }}-->
        <!--        </router-link>-->
        <ul
          class="hamburger-contents__list-lang"
          v-if="
            !$route.path.includes('confirmation') ||
            !$route.path.includes('login')
          "
        >
          <li
            class="hamburger-contents__list-lang--item flex-all-center"
            :class="{ active: isJaActive }"
          >
            <a :href="`/${switchLangPath}`" class="link"> JP </a>
          </li>
          <li
            class="hamburger-contents__list-lang--item flex-all-center"
            :class="{ active: isEnActive }"
          >
            <a :href="`/en/${switchLangPath}`" class="link"> EN </a>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
import header from "../../../assets/constants/header.json";
import cognito from "../../../plugins/cognito";
export default {
  data() {
    return {
      checked: false,
      isJaActive: this.$route.path.split("/")[1] !== "en",
      isEnActive: this.$route.path.split("/")[1] === "en",
      switchLangPath:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.fullPath.split("/").slice(2).join("/")
          : this.$route.fullPath.split("/").slice(1).join("/"),
    };
  },
  methods: {
    removeCheck() {
      if (this.checked) {
        this.checked = false;
      }
    },
    onLogout: function () {
      cognito.logout();
      this.$router.push("/company/login");
    },
  },
  computed: {
    headerJson: function () {
      return header;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "CompanyHeader",
};
</script>

<style scoped>
.header {
  width: 100%;
  &::before {
    content: "";
    display: block;
    height: 5px;
    background: url("../../../assets/images/border/border_header_sp.svg") center;
  }

  &__section {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
    padding: 18px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  &__title {
    margin: 0;
    line-height: 1;
  }

  .none-checkbox {
    display: none;
  }

  &__menu {
    width: 35px;
    height: 29px;
    position: relative;

    .line {
      position: absolute;
      left: 0;
      width: 35px;
      height: 3px;
      border-radius: 4px;
      background-color: var(--defaultBlackColor);
      transition: all 0.4s;
    }

    .line:nth-of-type(1) {
      top: 0;
    }

    .line:nth-of-type(2) {
      top: 13px;
    }

    .line:nth-of-type(3) {
      bottom: 0;
    }
  }

  .layer-hamburger {
    display: none;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s ease-in-out;
  }

  .hamburger-contents {
    position: fixed;
    top: 75px;
    right: 0;
    z-index: 1;
    overflow: auto;
    width: 100%;
    height: 100%;
    padding: 8px 0 0 0;
    background-color: var(--defaultWhiteColor);
    transition: all 0.5s ease-in-out;
    -webkit-transform: translateX(105%);
    transform: translateX(105%);
    &__confirm-link,
    .logout-button {
      width: 200px;
      height: 45px;
      margin: 25px 0 0 40px;
      border: solid 1px #000;
      font-weight: bold;
    }
    &__list-lang {
      margin: 25px 0 0 40px;
      display: flex;
      &--item {
        width: 60px;
        height: 60px;
        border: solid 1px #000;
        &:not(:first-of-type) {
          margin: 0 0 0 10px;
        }
        .link {
          font-size: 36px;
          font-weight: bold;
        }
      }
      .active {
        background-color: var(--defaultBlackColor);
        .link {
          color: var(--defaultWhiteColor);
        }
      }
    }
  }

  #check-hamburger:checked ~ .layer-hamburger {
    display: block;
  }

  #check-hamburger:checked ~ .hamburger-contents {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    box-shadow: 6px 0 25px rgba(0, 0, 0, 0.15);
  }

  #check-hamburger:checked ~ .header__menu .line:nth-of-type(1) {
    transform: translateY(13px) rotate(-45deg);
  }

  #check-hamburger:checked ~ .header__menu .line:nth-of-type(2) {
    opacity: 0;
  }

  #check-hamburger:checked ~ .header__menu .line:nth-of-type(3) {
    transform: translateY(-13px) rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/company/CompanyHeader.vue